import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateSelect", "timeSelect", "timeWrapper", "submitBtn"]
  static values = { url: String }

  connect() {
    this.toggleTimeVisibility()
  }

  async dateChanged() {
    const date = this.dateSelectTarget.value
    const timeSelect = this.timeSelectTarget

    timeSelect.innerHTML = ""
    this.submitBtnTarget.disabled = true

    if (!date) {
      this.toggleTimeVisibility()
      return
    }

    const url = `${this.urlValue}?date=${date}`
    const response = await fetch(url, {
      headers: { "Accept": "application/json" }
    })
    const times = await response.json()

    if (times.length === 0) {
      const option = document.createElement("option")
      option.value = ""
      option.textContent = this.timeSelectTarget.dataset.emptyText
      timeSelect.appendChild(option)
      timeSelect.disabled = true
    } else {
      const placeholder = document.createElement("option")
      placeholder.value = ""
      placeholder.textContent = this.timeSelectTarget.dataset.placeholderText
      timeSelect.appendChild(placeholder)

      times.forEach(t => {
        const option = document.createElement("option")
        option.value = t.value
        option.textContent = t.label
        timeSelect.appendChild(option)
      })
      timeSelect.disabled = false
    }

    this.toggleTimeVisibility()
  }

  timeChanged() {
    this.submitBtnTarget.disabled = !this.timeSelectTarget.value
  }

  toggleTimeVisibility() {
    const hasDate = this.dateSelectTarget.value !== ""
    this.timeWrapperTarget.classList.toggle("hidden", !hasDate)
  }
}
